import * as R from 'ramda';
import platform from 'rangeConfig/shared/utils/platform';
import { MainMenu } from 'rangeConfig/@types';
import hideDoors from 'rangeConfig/shared/behaviors/hideDoors';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import withCategoryFilter from 'rangeConfig/shared/widgets/withCategoryFilter';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import lightsProductListConfig from './productListConfig';
import withInlineMessage from 'rangeConfig/shared/widgets/withInlineMessage';
import CategoryAdditionalInlineMessage from 'components/ProductSidebar/CategoryWidget/CategoryAdditionalInlineMessage';
import enableNightModeBehavior from 'rangeConfig/shared/behaviors/enableNightMode';
import disableNightModeBehavior from 'rangeConfig/shared/behaviors/disableNightMode';
import withErrorMessage from 'rangeConfig/shared/widgets/withErrorMessage';
import { getNoFramesInSceneErrorMessage } from 'rangeConfig/shared/utils/errorMessages';
import ErrorMessageInline from 'rangeConfig/shared/widgets/ErrorMessageInline';
import { CoreApi } from '@inter-ikea-storageone/range';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';

const OuterLightsSwiper = R.pipe(withCategoryFilter(['outerLight']));

const InnerLightsSwiper = R.pipe(withCategoryFilter(['innerLight']));

const widgets = {
  desktop: [
    {
      id: 'error-message-no-frames-in-scene',
      component: withErrorMessage(getNoFramesInSceneErrorMessage)(ErrorMessageInline),
      hidden: (coreApi: CoreApi) => hideNoFramesInSceneErrorMessage(coreApi)
    },
    {
      id: 'additional-inline-message',
      component: withInlineMessage(
        'storageone.lightsDriversAdditionalInfo',
        true
      )(CategoryAdditionalInlineMessage)
    },
    {
      id: 'lights-product-list',
      component: withProducts(ProductList, lightsProductListConfig)
    }
  ],
  mobile: [
    {
      id: 'outer-lights-product-list',
      component: OuterLightsSwiper(withProducts(ProductSwiper, lightsProductListConfig)),
      title: 'storageone.productListOuterLights'
    },
    {
      id: 'inner-lights-product-list',
      component: InnerLightsSwiper(withProducts(ProductSwiper, lightsProductListConfig)),
      title: 'storageone.productListInnerLights'
    }
  ]
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.productListLightsTitle',
  behaviors: {
    productGroupEntered: [hideDoors, enableNightModeBehavior],
    productGroupExited: [showDoors, disableNightModeBehavior]
  },
  widgets: widgets[platform]
};

export default mainMenu;
